import React, { useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, withStyles } from "@material-ui/core";
import t from "../../../languages/pl";
import CancelAcceptForm from "../../Common/CancelAcceptForm";
import ConfirmationDialog from "../../Common/ConfirmationDialog";
import NewDriverForm from "./NewDriverForm";
import { mapDriverDto } from './../../../requests/mapApiObject';
import withSubordinateUser from '../../HOC/withSubordinateUser';
import { compose } from "recompose";
import { connect } from "react-redux";

const AddDriver = props => {
    const {
        open,
        onClose,
        isEdit = false,
        data,
        groups,
        onSubmit,
        onDelete,
        nonAdminUser,
        onMobileAppKeyGenerate,
        isPKP
    } = props;
    const formRef = useRef(null);
    const [deleteDriver, setDeleteDriver] = useState(false);

    const handleSubmit = state => {
        onSubmit && onSubmit(data ? data.kierowca_id : null, mapDriverDto(state));
    };

    const handleDriverDelete = id => {
        onDelete && onDelete(id);
        setDeleteDriver(false);
    };

    return (
        <Dialog
            open={open}
            onClose={onClose}
            fullWidth
            maxWidth="sm"
        >
            <DialogTitle>
                {isEdit ? t.editDriver : t.addDriver}
            </DialogTitle>
            <DialogContent>
                <NewDriverForm
                    ref={formRef}
                    data={data}
                    groups={groups}
                    onSubmit={handleSubmit}
                    isEdit={isEdit}
                    isPKP={isPKP}
                    onMobileAppKeyGenerate={() => onMobileAppKeyGenerate(data.kierowca_id)}
                />
            </DialogContent>
            <DialogActions>
                {
                    isEdit
                    &&
                    <>
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={() => setDeleteDriver(true)}
                        >
                            {t.deleteDriver}
                        </Button>
                        <ConfirmationDialog
                            open={deleteDriver}
                            onClose={() => setDeleteDriver(false)}
                            onSubmit={handleDriverDelete}
                            id={data.kierowca_id}
                            action={t.deleteThisDriver}
                        />
                    </>
                }
                <CancelAcceptForm
                    onCancel={onClose}
                    onSubmit={() => formRef.current.dispatchEvent(new Event("submit", {
                        cancelable: true,
                        bubbles: true
                    }))}
                    disableSubmit={nonAdminUser}
                />
            </DialogActions>
        </Dialog>
    );
};

AddDriver.propTypes = {
    classes: PropTypes.object,
    open: PropTypes.bool,
    onClose: PropTypes.func,
    data: PropTypes.object,
    isEdit: PropTypes.bool,
    onSubmit: PropTypes.func,
    onDelete: PropTypes.func,
    groups: PropTypes.array,
    onMobileAppKeyGenerate: PropTypes.func,
    //suboridnateUserHOC
    nonAdminUser: PropTypes.bool,
    isPKP: PropTypes.bool
};


const mapStateToProps = (state) => ({
    isPKP: state.authReducer.isPKP,
});

export default compose(
    withSubordinateUser,
    connect(
        mapStateToProps
    )
)(AddDriver);
